import React, { useEffect, useRef, useState } from "react";
import styles from "./AdharRegistrartion.module.scss";
import {
  getAbhaUserByAbhaAddress,
  verifyGetByAbhaAddress,
  abhaAddressUserDetails,
} from "../../../../store/slices/abhaRegistrationSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  MAX_OTP_RESEND_ATTEMPTS,
  getOtpResendAttemptMessage,
} from "./otpResendAttempts";

const AbhaAddressVerification = ({
  setAadharNumber,
  clinicId,
  setModalVisible,
  setShowRegistrationModal,
  loading,
}) => {
  const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);
  const [showAbhaAddressField, setShowAbhaAddressField] = useState(true);
  const [inputError, setInputError] = useState("");
  const [abhaAddress, setAbhaAddress] = useState("");
  const [verificationMethod, setVerificationMethod] = useState("aadhaar");
  const [scopeType, setScopeType] = useState("aadhaar-verify");
  const [otpSystem, setOtpSystem] = useState("aadhaar");
  const [showOtpField, setShowOtpField] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(20);
  const OTP_RESEND_TIMEOUT = 60;
  const inputRefs = useRef([]);
  const [abhaOtpGenerateMsg, setAbhaOtpGenerateMsg] = useState("");
  const [resendCount, setResendCount] = useState(0);
  const [maxAttemptsReached, setMaxAttemptsReached] = useState(false);

  useEffect(() => {
    let interval;
    if (showOtpField && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOtpField, timer]);

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setAbhaAddress(value);
    setInputError("");
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpChange = (e, index) => {
    setOtpError("");
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) inputRefs.current[index + 1]?.focus();
    }
  };

  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const handleNextClick = async () => {
    setAadharNumber("");
    if (!abhaAddress.trim()) {
      setInputError("ABHA Address is required");
      return;
    }
    try {
      const response = await dispatch(
        getAbhaUserByAbhaAddress({
          clinicId,
          abhaAddress: abhaAddress,
          scopeType,
          otpSystem,
          token
        })
      ).unwrap();
      if (response?.success) {
        setAbhaOtpGenerateMsg(response?.result?.list);
        setShowAbhaAddressField(false);
        setShowOtpField(true);
        setTimer(OTP_RESEND_TIMEOUT);
        return;
      }
      setInputError("Invalid ABHA Address. Please try again.");
    } catch (err) {
      setInputError("Something went wrong. Please try again.");
    }
  };

  const handleResendOtp = async () => {
    if (timer > 0 || resendCount >= MAX_OTP_RESEND_ATTEMPTS) return;

    try {
      setOtpError("");
      const response = await dispatch(
        getAbhaUserByAbhaAddress({
          clinicId,
          abhaAddress: abhaAddress,
          scopeType,
          otpSystem,
          token
        })
      ).unwrap();
      if (response?.success) {
        setOtp(["", "", "", "", "", ""]);
        setAbhaOtpGenerateMsg(response?.result?.list);
        setTimer(OTP_RESEND_TIMEOUT);
        const nextCount = resendCount + 1;
        setResendCount(nextCount);
        if (nextCount >= MAX_OTP_RESEND_ATTEMPTS) {
          setMaxAttemptsReached(true);
        }
        return;
      }

      setOtpError("Failed to resend OTP. Please try again.");
    } catch (err) {
      console.error("Error during OTP resend:", err);
      setOtpError("Failed to resend OTP. Please try again.");
    }
  };

  const handleFinalNextClick = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6 || !enteredOtp) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }
    setOtpError("");
    try {
      const response = await dispatch(
        verifyGetByAbhaAddress({ clinicId, otp: enteredOtp, scopeType,token})
      ).unwrap();
      if (response?.result?.list === "success") {
        const userDetailsResponse = await dispatch(
          abhaAddressUserDetails({ clinicId,token })
        );
        if (userDetailsResponse?.payload?.success) {
          setOtpError("");
          setShowRegistrationModal(false);
          setModalVisible(true);
          return;
        }
        setOtpError("Something went wrong. Please try again");
      } else {
        setOtpError("Invalid OTP. Please try again.");
      }
    } catch (err) {
      setOtpError("something went wrong. Please try again.");
    }
  };

  return (
    <>
      {showAbhaAddressField && (
        <div
          className={`d-flex flex-wrap gap-3 align-items-end ${styles.consent}`}
        >
          <div className="w-100">
            <label className="fw-bold mb-2 d-block">ABHA Address</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter ABHA Address"
              value={abhaAddress}
              onChange={handleAddressChange}
            />
          </div>

          {inputError && <p className="text-danger small mt-2">{inputError}</p>}

          <div className="w-100 mt-3">
            <label className="fw-bold mb-2 d-block">
              Verify With
              <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                (Select which method you want to verify with)
              </span>
            </label>

            <div className="d-flex gap-3">
              <div
                className={`px-4 py-2 rounded border ${
                  verificationMethod === "aadhaar"
                    ? "bg-primary text-white border-primary"
                    : "bg-light text-dark"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setVerificationMethod("aadhaar");
                  setScopeType("aadhaar-verify");
                  setOtpSystem("aadhaar");
                }}
              >
                Aadhaar OTP
              </div>
              <div
                className={`px-4 py-2 rounded border ${
                  verificationMethod === "abha"
                    ? "bg-primary text-white border-primary"
                    : "bg-light text-dark"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setVerificationMethod("abha");
                  setScopeType("mobile-verify");
                  setOtpSystem("abdm");
                }}
              >
                ABHA OTP
              </div>
            </div>
          </div>

          <div className="text-end w-100">
            <button
              className="btn btn-primary"
              onClick={handleNextClick}
              disabled={loading}
            >
              {loading ? "Processing..." : "Next"}
            </button>
          </div>
        </div>
      )}

      {showOtpField && (
        <div className={styles.adhaarDiv}>
          <p>Confirm OTP</p>
          <label className="col-form-label">{abhaOtpGenerateMsg}</label>
          <div className="d-flex gap-2 mt-2">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                className="form-control text-center"
                value={digit}
                onChange={(e) => handleOtpChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                maxLength={1}
                ref={(el) => (inputRefs.current[index] = el)}
                style={{ width: "4rem" }}
              />
            ))}
          </div>

          {otpError && <p className="text-danger small mt-2">{otpError}</p>}
          {resendCount > 0 && (
            <p
              className={`small mt-2 mb-0 ${
                resendCount >= MAX_OTP_RESEND_ATTEMPTS
                  ? "text-danger"
                  : "text-success"
              }`}
            >
              {getOtpResendAttemptMessage(resendCount)}
            </p>
          )}

          <div className="mt-2">
            {!maxAttemptsReached ? (
              <>
                <small className="fs-13">Didn't receive the OTP?</small>{" "}
                <small
                  onClick={handleResendOtp}
                  style={{
                    cursor: timer > 0 ? "not-allowed" : "pointer",
                    color: timer > 0 ? "gray" : "blue",
                    marginLeft: "0.5rem",
                  }}
                >
                  Resend OTP
                </small>
                <span className="ms-3">Time left: {formatTimer(timer)}</span>
              </>
            ) : (
              <div className="text-black fs-13">
                Resend OTP limit reached. Please try again later.
              </div>
            )}
          </div>

          <div className="text-end mt-3">
            <button
              className="btn btn-success"
              onClick={handleFinalNextClick}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Verifying...
                </>
              ) : (
                "Verify OTP"
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AbhaAddressVerification;
